import { Controller } from "stimulus"

// Quantity counter with increment/decrement buttons.
//
// Usage:
//   .d-flex.align-items-center.gap-2{"data-controller" => "qty-counter", "data-qty-counter-min-value" => "0", "data-qty-counter-max-value" => "100", "data-qty-counter-step-value" => "1"}
//     %button{"data-action" => "click->qty-counter#decrement"} -
//     %input{"data-qty-counter-target" => "input", type: "text", value: "1"}
//     %button{"data-action" => "click->qty-counter#increment"} +
//
export default class extends Controller {
  static targets = ["input"]
  static values = { min: Number, max: Number, step: Number }

  connect() {
    if (!this.hasMinValue) this.minValue = 0
    if (!this.hasMaxValue) this.maxValue = 999
    if (!this.hasStepValue) this.stepValue = 1
  }

  increment() {
    var current = this.currentValue()
    var next = current + this.stepValue
    if (next <= this.maxValue) {
      this.inputTarget.value = next
    }
  }

  decrement() {
    var current = this.currentValue()
    var next = current - this.stepValue
    if (next >= this.minValue) {
      this.inputTarget.value = next
    }
  }

  currentValue() {
    return parseInt(this.inputTarget.value, 10) || 0
  }
}
